import React from "react";
import ReactDOM from 'react-dom'
import { Redirect } from "react-router-dom";
import { buttonStyles, cardStyles, colorPallete, textStyles } from "../styles";
import { isMobileOnly, isTablet, isElectron, isAndroid, isIOS, deviceDetect, deviceType, isIOS13, isBrowser } from 'react-device-detect';

import FormatQuoteIcon from '@material-ui/icons/FormatQuote';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import DevicesIcon from '@material-ui/icons/Devices';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import VideoLibrarySharpIcon from '@material-ui/icons/VideoLibrarySharp';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo';
import SpeakerIcon from '@material-ui/icons/Speaker';
import CodeIcon from '@material-ui/icons/Code';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SettingsIcon from '@material-ui/icons/Settings';
import HomeIcon from "@material-ui/icons/Home";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faGraduationCap, faUniversity, faBook, faBookmark, faHeadphones, faNewspaper, faTabletAlt, faVideo, faHome, faCog, faUserMd
} from '@fortawesome/free-solid-svg-icons'
import { trackPage } from "../actions";
import { AISAPPID, AISKEY } from "./globals";

// console.log(`typeof AUAID: ${typeof AUAID} | ${AUAID}`);

export const getAuth = () => {
    let obj = {
        mcid: 'core_search_page',
        key: ''
    }

    if (typeof localStorage.auth_feedback !== 'undefined' && localStorage.auth_feedback !== null) {
        obj = JSON.parse(localStorage.auth_feedback);
    } else if (typeof localStorage.auau_auth_feedback !== 'undefined' && localStorage.auau_auth_feedback !== null) {
        obj = JSON.parse(localStorage.auau_auth_feedback);
    }

    console.log(obj);

    return obj;
}

export const getIcon = (icon, fontSize) => {
    if (typeof fontSize === 'undefined' || fontSize === null) { fontSize = "2.5em"; }
    // console.log('icon: ', icon);
    switch(icon) {
        case 'CoursesIcon': {
            return <FontAwesomeIcon icon={faGraduationCap} />;
        }
        case 'TranscriptsIcon': {
            return <FontAwesomeIcon icon={faUniversity} />;
        }
        case 'CoreCurriculumIcon': {
            return <FontAwesomeIcon icon={faBook} />;
        }
        case 'BookMarksIcon': {
            return <FontAwesomeIcon icon={faBookmark} />;
        }
        case 'PodCastsIcon': {
            return <FontAwesomeIcon icon={faHeadphones} />;
        }
        case 'GuideLinesIcon': {
            return <FontAwesomeIcon icon={faNewspaper} />;
        }
        case 'UpdateSeriesIcon': {
            return <FontAwesomeIcon icon={faTabletAlt} />;
        }
        case 'CoreCurriculumVideosIcon': {
            return <FontAwesomeIcon icon={faVideo} />;
        }
        case 'SpeakerIcon': {
            return <SpeakerIcon style={{fontSize: fontSize}} />;
        }
        case 'FormatQuoteIcon': {
            return <FormatQuoteIcon style={{fontSize: fontSize}} />;
        }
        case 'LocalHospitalIcon': {
            return <LocalHospitalIcon style={{fontSize: fontSize}} />;
        }
        case 'QuestionAnswerIcon': {
            return <QuestionAnswerIcon style={{fontSize: fontSize}} />;
        }
        case 'DevicesIcon': {
            return <DevicesIcon style={{fontSize: fontSize}} />;
        }
        case 'LibraryBooksIcon': {
            return <LibraryBooksIcon style={{fontSize: fontSize}} />;
        }
        case 'VideoLibrarySharpIcon': {
            return <VideoLibrarySharpIcon style={{fontSize: fontSize}} />;
        }
        case 'VideoLibraryIcon': {
            return <VideoLibraryIcon style={{fontSize: fontSize}} />;
        }
        case 'AssessmentIcon': {
            return <AssessmentIcon style={{fontSize: fontSize}} />;
        }
        case 'PictureAsPdfIcon': {
            return <PictureAsPdfIcon style={{fontSize: fontSize}} />;
        }
        case 'OndemandVideoIcon': {
            return <OndemandVideoIcon style={{fontSize: fontSize}} />;
        }
        case 'CodeIcon': {
            return <CodeIcon style={{fontSize: fontSize}} />;
        }
        case 'HomeIcon': {
            return <FontAwesomeIcon icon={faHome} />;
            // return <HomeIcon style={{fontSize: fontSize}} />
        }
        case 'AccountCircleIcon': {
            return <FontAwesomeIcon icon={faUserMd} />;
            // return <AccountCircleIcon style={{fontSize: fontSize}} />
        }
        case 'SettingsIcon': {
            return <FontAwesomeIcon icon={faCog} />;
            // return <SettingsIcon style={{fontSize: fontSize}} />
        }
        default: {
            return null;
        }
    }
}

export const stylePicker = (type, category) => {
    const classes = styleCategory(category);
    switch (type) {
        case "primary":
            return classes.primary;
        case "secondaryBlue":
            return classes.secondaryBlue;
        case "secondaryGreen":
            return classes.secondaryGreen;
        case "neutralLight":
            return classes.neutralLight;
        case "neutralDark":
            return classes.neutralDark;
        case "neutralGreen":
            return classes.neutralGreen;
        case "accentGreen":
            return classes.accentGreen;
        case "accentAqua":
            return classes.accentAqua;
        case "accentBlue":
            return classes.accentBlue;
        case "accentRed":
            return classes.accentRed;
        case "accentOrange":
            return classes.accentOrange;
        case "accentYellow":
            return classes.accentYellow;
        case "questionButtons":
            return classes.questionButtons;
        case "dynamicButton":
            return classes.dynamicButton;
        case "trueQuestionButtons":
            return classes.trueQuestionButtons;
        default:
            return classes.primary;
    }
};

export const logErr = () => {
    // console.error();
};

export const colorPicker = color => {
    const colors = colorPallete();
    switch (color) {
        case "primary":
            return colors.primary;
        case "secondaryBlue":
            return colors.secondaryBlue;
        case "secondaryGreen":
            return colors.secondaryGreen;
        case "neutralLight":
            return colors.neutralLight;
        case "neutralDark":
            return colors.neutralDark;
        case "neutralGreenCard":
            return colors.neutralGreenCard;
        case "neutralGreen":
            return colors.neutralGreen;
        case "neutralBlue":
            return colors.neutralBlue;
        case "neutralBlueCard":
            return colors.neutralBlueCard;
        case "neutralBlueText":
            return colors.neutralBlueText;
        case "accentGreen":
            return colors.accentGreen;
        case "accentAqua":
            return colors.accentAqua;
        case "accentBlue":
            return colors.accentBlue;
        case "accentRed":
            return colors.accentRed;
        case "accentOrange":
            return colors.accentOrange;
        case "accentYellow":
            return colors.accentYellow;
        case "questionButtons":
            return colors.questionButtons;
        case "dynamicButton":
            return colors.dynamicButton;
        case "trueQuestionButtons":
            return colors.trueQuestionButtons;
        case "correctGradedButtons":
            return colors.correctGradedButtons;
        case "correctQuestionButtons":
            return colors.correctQuestionButtons;
        case "incorrectGradedButtons":
            return colors.incorrectGradedButtons;
        case "incorrectQuestionButtons":
            return colors.incorrectQuestionButtons;
        case "neutralLightCard":
            return colors.neutralLightCard
        case "neutralLightText":
            return colors.neutralLightText
        case "secondaryBlueCard":
            return colors.secondaryBlueCard
        case "secondaryBlueText":
            return colors.secondaryBlueText
        case "accentYellowCard":
            return colors.accentYellowCard
        case "accentYellowText":
            return colors.accentYellowText
        case "accentRedCard":
            return colors.accentRedCard
        case "accentRedText":
            return colors.accentRedText
        case "accentBlueCard":
            return colors.accentBlueCard
        case "accentBlueText":
                return colors.accentBlueText
        case "secondaryGreenText":
            return colors.secondaryGreenText
        case "secondaryGreenCard":
            return colors.secondaryGreenCard
        case "submitButtons":
            return colors.submitButtons
        default:
            return;
    }
};

const styleCategory = type => {
    switch (type) {
        case "button":
            return buttonStyles();
        case "deck":
            return cardStyles();
        case "text":
            return textStyles();
        default:
            return buttonStyles();
    }
};

export const textValidate = (text, type) => {
    if (type === "id") {
        return /^[0-9]{8}$/.test(text);
    }
    if (type === "email") {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            text
        );
    }
    if (type === "password") {
        return /^\S{6,}$/.test(text);
    }
};

export const hashString = (string) => {
    let hash = 0, i, chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
        chr     = string.charCodeAt(i);
        hash    = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export const deviceData = (location, action, uri) => {
    if (typeof action !== 'undefined') { action = 'navigate'; }
    let pageVia = 'AUAUniversity App';

    let _type = 'mobile';

    if (isTablet) { _type = 'tablet' } else if (isElectron) { _type = 'testing' }

    if (isAndroid) {
        pageVia = `AUAUniversity Android ${_type} App`;
    } else if (isIOS) {
        pageVia = `AUAUniversity iOS ${_type} App`;
    } else if (isElectron) {
        pageVia = `AUAUniversity Electron ${_type} App`;
    }    

    let device = deviceDetect();
    let obj = {
        pathname : '',
        pagevia : pageVia,
        action : action,
        os : 'unknown',
        ua : 'unknown',
    };

    if (typeof uri === 'string') {
        obj.pathname = `remoteURL - ${uri}`
    } else if (typeof location !== 'undefined') {
        obj.pathname = location.pathname;
    } else {
        return false;
    }

    if (isElectron || isBrowser) {
        obj.os = device.osName + ' ' + device.osVersion;
        obj.ua = device.userAgent;

    } else if (isIOS) {
        obj.os = device.os + ' ' + device.model + ' ' + device.osVersion;
        obj.ua = device.ua;
    } else if (isAndroid) {
        obj.os = 'android';
        obj.ua = 'android';

        if (typeof device.os !== 'undefined' && typeof device.model !== 'undefined' && typeof device.osVersion !== 'undefined') {
            obj.os = device.os + ' ' + device.model + ' ' + device.osVersion;
        } else if (typeof device.osName !== 'undefined') {
            obj.os = device.osName + ' ' + device.osVersion;
        }

        if (typeof device.ua !== 'undefined') {
            obj.ua = device.ua;
        } else if (typeof device.userAgent !== 'undefined') {
            obj.ua = device.userAgent;
        }
    }

    return obj;
}

export const remoteURL = (uri) => {
    trackPage(null, deviceData(null,'navigate',uri));
    // console.log(_track);
    if (window.cordova) {
        if (window.cordova.InAppBrowser) {
            let type = '_blank';
            return window.cordova.InAppBrowser.open(uri, type, 'location=yes');
        }          
    }

    return null;
}

export const makeList = (arrs) => {
    let r = '';
    let c = 0;
    for (const index in arrs) {
        if (arrs[index]) {
            if (c > 0) {
                r += ',';
            }

            r += index;
            c++;
        }
    }
    return r;
}

export const scrollTop = (id, offset) => {
    if (typeof id === 'undefined') { id = 'root'; }
    if (typeof offset === 'undefined') { offset = 54; }
    let elem = document.getElementById(id);
    // elem = ReactDOM.findDOMNode(id)
    if (elem) {
        // console.log('elem: ', elem);
        return elem.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
        return elem.scrollIntoView(offset);
        elem.scrollTo({top: offset, behavior: "smooth"});
    }

    return false;
}

export const goTo = (id, offset) => {
    // console.log(`id: ${id}`);
    if (typeof id === 'undefined') { id = 'root'; }
    if (typeof offset === 'undefined') { offset = 54; }

    return scrollTop(id, offset);
}

export const pageGoTo = (id, offset) => {
    if (typeof id === 'undefined') { id = 'root'; }
    if (typeof offset === 'undefined') { offset = 54; }

    // console.log(`id: ${id}`);
    return goTo(id, offset);
}

export const killCopy = () => {
    return false;
}

export const reEnable = () => {
    return true;
}

export const preventCopy = () => {
    if (isElectron || isBrowser) {
        document.onselectstart = new Function ("return false")

        if (window.sidebar) {
            document.onmousedown = killCopy
            document.onclick = reEnable
        }
    } else {
        return false;
    }
}

export const setContainer = (bool) => {
    let obj = { 
        padding: "0 64px 32px", 
        margin: "24px 0 0", 
        width: "calc(100% - 128px)", 
        // height: "calc(100vh - 54px)", 
        // overflowY: "auto"
    }    

    return obj;
}

export const checkPersistantLogin = async (func) => {
    // console.log('persistantLogin');
    if (
        typeof localStorage.getItem('auau_login_dt') !== 'undefined' && 
        localStorage.getItem('auau_login_dt') != null
    ) {    
        const _date = new Date();
        let _expire = Number(localStorage.getItem('auau_login_dt'));
        const _now = Number(Date.parse(_date));

        if (_now < _expire && typeof func === 'function') {
            await func;

            return (<Redirect 
                to={{
                    pathname: '/splash'
                }}
            />)
        } else {
            return null;
        }
    } else {
        return null;
    }
}

export const toggleClass = (id, cls) => {
    let element = document.getElementById(id);
    // console.log('element: ', element);

    if (element) {
        if (element.classList) {
            element.classList.toggle(cls);
        } else {
            const classes = element.className.split(" ");
            let i = classes.indexOf(cls);
        
            if (i >= 0)
                classes.splice(i, 1);
            else {
                classes.push(cls);
                element.className = classes.join(" ");
            }
        }
    }

    return null;
}

export const getRandomIdentifier = (base) => {
    if (typeof base === 'undefined') { base = 16; }
    let _d = Date.now();

    // return parseInt(_d, base);

    return _d.toString(base).toUpperCase();
}

export const createMarkup = props => {
    return { __html: props };
};

export const showModal = (data) => {
    // console.log('showModal data: ', data);
    return false;
}

export const parseHTMLEvent = (str) => {
    let temp = '';
    let target = '_blank';

    if (isElectron) { target = '_new'; }
    else if (isAndroid) { target = '_system'; }

    if (str.includes('showModal')) {
        temp = str.replace('showModal(', "");
        temp = temp.replace(/'/ig, '"');
        temp = temp.replace(')',"");

        let obj = JSON.parse(temp);
        obj.uri = '#ref_' + obj.id;
        
        return {
            func: () => showModal(obj),
            _object: obj,
            type: 'coreref'
        }
    } else if (str.includes('remoteURL')) {
        // console.log('str: ', str);
        let temp = str.replace('remoteURL(', '');
        temp = temp.replace(')','');

        let obj = {
            uri: temp,
            target: target
        }

        // console.log('obj: ', obj);

        return {
            func: () => remoteURL(obj.uri),
            _object: obj,
            type: 'coreimg'
        }
    } else {
        return {
            func: null,
            _object: {
                str: str,
                uri: 'https://auaunet.org'
            },
            type: 'new_type'
        }
    }
}

export const checkDate = (epoch, interval, _ls) => {
    if (typeof interval === 'undefined') { interval = 1 }
    let base = 1000 * 60 * 60 * Number(interval);
    let now = Date.now();
    let diff = now - Number(epoch);
    let _bool = diff > base;
    let mins = Math.trunc(diff / (1000 * 60));

    // console.log(` diff: ${diff} \n base: ${base} \n mins: ${mins} \n _bool: ${_bool} `);

    /**
     * true - retrive new data
     * false - use old data
     */

    if (typeof _ls === 'string') { 
        // console.log(_ls);
        localStorage.setItem(_ls, now);
    }

    return _bool;
}

export const unlockScreen = () => {
    if (isIOS || isAndroid) {
        return window.screen.orientation.unlock();
    } else {
        return null;
    }
}

export const lockScreen = (str) => {
    // console.log(`str: ${str}`);

    if (isIOS || isAndroid) {
        return window.screen.orientation.lock(str);
    } else {
        return null;
    }
}

export const getThisYear = () => {
    let _d = new Date();

    return _d.getFullYear();
}

export var USERDATA = {mcid: null, key: null};

export const setUserData = (data) => {
    // USERDATA = data;
    console.log(data)
    return null;
}

export const aaInit = () => {
    return null;
};

export const aisSearch = (data, user) => {
    let _obj = {
        userToken: user.mcid,
        eventName: 'Core Section Clicked',
        index: user.index,
        queryID: data.__queryID,
        objectIDs: [data.objectID],
        positions: [data.__position],
    }

    // console.log(aa);

    return null;
}